import React, { FC } from 'react';
import { SC } from '../../../styles/theme';
import { BRAND } from '../../../constants/main';
import { HomePageOptionsCardStyled } from './HomePageOptionsCardStyled';
import { HomePageOptionsCardStyledAP } from './AP/HomePageOptionsCardStyled.AP';
import { HomePageOptionsCardStyledAC } from './AC/HomePageOptionsCardStyled.AC';
import { HomePageOptionsCardStyledDS } from './DS/HomePageOptionsCardStyled.DS';
import { BrandTypes } from '../../../types/brands';

export interface HomePageOptionsCardProps extends SC {
    routeTitle: string;
    imageUrl?: string;
    buttonText: string;
    onRedirect?: () => void;
}

const HomePageOptionsCard: FC<HomePageOptionsCardProps> = (props): JSX.Element => {
    if (BRAND === BrandTypes.AC) return <HomePageOptionsCardStyledAC {...props} />;
    if (BRAND === BrandTypes.AP) return <HomePageOptionsCardStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <HomePageOptionsCardStyledDS {...props} />;
    return <HomePageOptionsCardStyled {...props} />;
};

export default HomePageOptionsCard;
